import axios from 'axios';
import Cookies from "universal-cookie";
function getToken() {
  const cookies = new Cookies();
  return cookies.get("token");
}


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getAuthHeaders = () => ({
  headers: { authorization: `Bearer ${getToken()}` }
});

// Get articles for a project
export function getArticles(projectId) {
  const url = `${API_BASE_URL}/articles?project_id=${projectId}`;
  return axios.get(url, getAuthHeaders());
}

// Create article
export function createArticle(articleData) {
  const url = `${API_BASE_URL}/articles`;
  return axios.post(url, articleData, getAuthHeaders());
}

// Update article
export function updateArticle(articleId, articleData) {
  const url = `${API_BASE_URL}/articles/${articleId}`;
  return axios.put(url, articleData, getAuthHeaders());
}

// Delete article
export function deleteArticle(articleId) {
  const url = `${API_BASE_URL}/articles/${articleId}`;
  return axios.delete(url, getAuthHeaders());
}

// Create section
export function createSection(sectionData) {
  const url = `${API_BASE_URL}/article-sections`;
  return axios.post(url, sectionData, getAuthHeaders());
}

// Update section
export function updateSection(sectionId, sectionData) {
  const url = `${API_BASE_URL}/article-sections/${sectionId}`;
  return axios.put(url, sectionData, getAuthHeaders());
}

// Delete section
export function deleteSection(sectionId) {
  const url = `${API_BASE_URL}/article-sections/${sectionId}`;
  return axios.delete(url, getAuthHeaders());
}

// Generate section content
export function generateSectionContent(sectionId, regenerate = false) {
  const url = `${API_BASE_URL}/article-sections/${sectionId}/generate-content`;
  return axios.post(url, { regenerate }, getAuthHeaders());
}

// Update section analyses
export function updateSectionAnalyses(sectionId, analysisUuids) {
  const url = `${API_BASE_URL}/article-sections/${sectionId}/analyses`;
  return axios.put(url, { analysis_uuids: analysisUuids }, getAuthHeaders());
}

// Add analysis to section
export function addAnalysisToSection(sectionId, analysisUuid) {
  const url = `${API_BASE_URL}/article-sections/${sectionId}/analyses/add`;
  return axios.post(url, { analysis_uuid: analysisUuid }, getAuthHeaders());
}

// Remove analysis from section
export function removeAnalysisFromSection(sectionId, analysisUuid) {
  const url = `${API_BASE_URL}/article-sections/${sectionId}/analyses/remove`;
  return axios.delete(url, { data: { analysis_uuid: analysisUuid }, ...getAuthHeaders() });
}

// Get article status
export function getArticleStatus(articleId) {
  const url = `${API_BASE_URL}/articles/${articleId}/status`;
  return axios.get(url, getAuthHeaders());
}

// Get section status
export function getSectionStatus(sectionId) {
  const url = `${API_BASE_URL}/article-sections/${sectionId}/status`;
  return axios.get(url, getAuthHeaders());
}

// Generate all sections for an article
export function generateAllSections(articleId, regenerateExisting = false) {
  const url = `${API_BASE_URL}/articles/${articleId}/generate-all-sections`;
  return axios.post(url, { regenerate_existing: regenerateExisting }, getAuthHeaders());
}

// Cross-check in-text citations against the reference list (and vice versa)
export function verifyCitations(articleId) {
  const url = `${API_BASE_URL}/articles/${articleId}/verify-citations`;
  return axios.get(url, getAuthHeaders());
}

// Ask where each uncited reference could legitimately be cited (read-only)
export function suggestReferencePlacements(articleId, references) {
  const url = `${API_BASE_URL}/articles/${articleId}/references/suggest-placements`;
  return axios.post(url, { references }, getAuthHeaders());
}

// Drop uncited entries from the bibliography
export function removeReferences(articleId, references) {
  const url = `${API_BASE_URL}/articles/${articleId}/references/remove`;
  return axios.post(url, { references }, getAuthHeaders());
}

// Insert an in-text citation at the end of a suggested passage
export function insertReferenceCitation(articleId, { section_id, passage, citation }) {
  const url = `${API_BASE_URL}/articles/${articleId}/references/insert-citation`;
  return axios.post(url, { section_id, passage, citation }, getAuthHeaders());
}
